import script from "./SetupBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupBadge.vue?vue&type=script&setup=true&lang=js"

import "./SetupBadge.vue?vue&type=style&index=0&id=258ed4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258ed4a6"]])

export default __exports__